import React, { useCallback, useMemo } from "react";
import { useFormikContext } from "formik";
import { JournalEntryDrawerFormikConfig } from "@components/accounting/journalEntryDrawer/JournalEntryDrawer";
import { useFinancialDocumentsQuery } from "@components/documents/useFinancialDocumentsQuery";
import { useScope } from "@state/scopeContext.lib";
import { JournalEntryDocument } from "@components/accounting/journalEntryDrawer/JournalEntryDocument";
import styles from "./JournalEntryDocuments.module.scss";
import { JournalEntryAddDocument } from "./JournalEntryAddDocument";

export const JournalEntryDocuments: React.FC = () => {
    const { workspaceId } = useScope();
    const formikContext = useFormikContext<JournalEntryDrawerFormikConfig>();
    const { values, setFieldValue } = formikContext;
    const { financialDocumentIds } = values.journalEntry;
    const documentIds = useMemo(
        () =>
            financialDocumentIds && financialDocumentIds.length > 0
                ? financialDocumentIds
                : [0],
        [financialDocumentIds],
    );

    const detachDocument = useCallback(
        (documentId: number) => {
            const currentDocumentIds = new Set(financialDocumentIds);

            currentDocumentIds.delete(documentId);
            setFieldValue(
                "journalEntry.financialDocumentIds",
                Array.from(currentDocumentIds),
            );
        },
        [setFieldValue, financialDocumentIds],
    );

    const { data: financialDocumentsResponse } = useFinancialDocumentsQuery({
        queryParams: {
            filters: {
                financialDocumentIds: documentIds,
            },
            page: 0, // hardcode value here because we are not expecting more than 100 documents attached
            limit: 100,
            workspaceId: workspaceId ?? "",
        },
    });

    return (
        <div className={styles.matchesContainer}>
            <div className={styles.matches}>
                <JournalEntryAddDocument />

                {financialDocumentsResponse &&
                    financialDocumentsResponse.data.length > 0 && (
                        <div className={styles.list}>
                            {financialDocumentsResponse.data.map((document) => (
                                <JournalEntryDocument
                                    key={document.id}
                                    financialDocument={document}
                                    detachDocument={detachDocument}
                                />
                            ))}
                        </div>
                    )}
            </div>
        </div>
    );
};
